import { render, staticRenderFns } from "./moTrends.vue?vue&type=template&id=8b044e18&"
import script from "./moTrends.vue?vue&type=script&lang=js&"
export * from "./moTrends.vue?vue&type=script&lang=js&"
import style0 from "./moTrends.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports